import './Cart.scss';

import React, { useCallback, useMemo } from 'react';

import Aside from '@/ebat/components/blocks/Standalone/Cart/Aside/Aside';
import Content from '@/ebat/components/blocks/Standalone/Cart/Content/Content';
import useManageCarts from '@/ebat/hooks/carts/useManageCarts';

import { CartDefaultProps, CartPropTypes } from './Cart.proptypes';

const Cart = ({ cart, disabled, isLoading, refetchCart }) => {
  const {
    isDisabled: isDisabledUseManageCarts,
    isUpdate,
    localCart,
    onDeleteCartItem,
    onPutCartItems,
    onUpdateLocalCartItem,
    onUpdateCartItem,
  } = useManageCarts({
    cart,
    disabled,
    isLoading,
    refetchCart,
  });

  const isDisabled = useMemo(() => {
    const blocked = disabled || isLoading || isDisabledUseManageCarts.disabled;

    return {
      disabled: blocked,
      loading: isLoading || isDisabledUseManageCarts.loading,
    };
  }, [disabled, isDisabledUseManageCarts, isLoading]);

  const handleModifyLocal = useCallback(
    ({ id, isSelected, isSelectedDiff, quantity }) => {
      onUpdateLocalCartItem({
        id,
        isSelected,
        isSelectedDiff,
        quantity,
      });
    },
    [onUpdateLocalCartItem],
  );

  const handleModify = useCallback(
    ({ id, isSelected, isSelectedDiff, quantity, onSuccess }) => {
      onUpdateCartItem({
        id,
        isSelected,
        isSelectedDiff,
        quantity,
        onSuccess,
      });
    },
    [onUpdateCartItem],
  );

  const handleRemove = useCallback(
    ({ id }) => {
      onDeleteCartItem({ id });
    },
    [onDeleteCartItem],
  );

  return (
    <div className="wrapper wrapper--nav-bottom">
      <section className="wrapper__section">
        <h1 className="h1 title" data-qa-id="title-h1">
          {localCart.name}
        </h1>
        <Content
          cart={localCart}
          className="standalone-cart__content"
          currentItems={localCart?.items}
          disabled={isDisabled.disabled}
          isLoading={isDisabled.loading}
          isUpdated={isUpdate()}
          onModify={handleModify}
          onModifyLocal={handleModifyLocal}
          onRemove={handleRemove}
          refetchCart={refetchCart}
        />
      </section>
      <aside className="wrapper__aside">
        <Aside
          cart={localCart}
          className="standalone-cart__aside"
          disabled={isDisabled.disabled}
          isLoading={isDisabled.loading}
          isUpdated={isUpdate()}
          onPutCartItems={onPutCartItems}
        />
      </aside>
    </div>
  );
};

Cart.defaultProps = {
  ...CartDefaultProps,
};

Cart.propTypes = {
  ...CartPropTypes,
};

export default Cart;
